import $ from 'jquery';
import FooterSelector from "./footer-selector";


class CreateInvoice {

	constructor() {
		if ($("#createInvoiceModal").length> 0) {
			this.init();
		}

	}

	initModal() {

		let body = $("#createInvoiceModal .modal-body");
		$(body).find("#vatfield input").change(e => {

			$(body).find("#vatprice, #vatzero").hide();
			$(body).find("#withVAT, #withoutVAT").hide();

			if ($(body).find("#vatfield input").prop("checked")) {
				$(body).find("#withVAT, #vatprice").show();
			} else {
				$(body).find("#withoutVAT, #vatzero").show();
			}
		}).change();
		
		new FooterSelector();
		
	}

	init() {

		$(".create-invoice-button").each((i, button) => {
			$(button).click(e => {
				let id = $(button).data("quotation");
				$("#createInvoiceModal button.btn-primary").data("id", id);
				$("#createInvoiceModal .modal-body").html("Loading...");

				$.ajax({
					data:{
						op: "temporaryInvoice",
						id: id
					},
					success: result => {
						$("#createInvoiceModal .modal-body").html(result.html);

						this.initModal();
					}
				});
			});
		});

		$("#createInvoiceModal button.btn-primary").click(e => {
			e.preventDefault();
			let id = $("#createInvoiceModal button.btn-primary").data("id");

            let description = [];
            $(".createinvoice-description").each((i, ee) => {
            	let id = $(ee).data("index");
            	description[id] = $(ee).val();
			})
            let date = $("#createinvoice-date").val();
			let vat = $("#createInvoiceModal #vatfield input").prop("checked") ? 1 : 0;
			
			$.ajax({
				data:{
					op: "createInvoice",
					id: id,
					description: description,
					date: date,
					vat: vat,
					footer: $("#selected_footer").val(),
					highlighted: $("#highlight_state").val(),
				}
			});
			
		})

	}

	init2() {

		Vue.component('create-invoice',  () => import('../components/CreateInvoice.vue'));

		const self = this;
		let vm = new Vue({
	        el: "#createInvoiceModal",
	        data: window.invoice_data,
	        methods: {
	            save() {
	                self.save(this.input)
	            }
	        }
	    });

	    $(".create-invoice").each((i, button) => {
	        $(button).click(e => {

	            this.client_id = $(button).data("client");
	            this.product_id = $(button).data("id");

	            $("#product_info").html("");
	            let info = window.invoice_product_info[this.product_id] 
            	if (info.estimates) {
            		$("#product_info").append($("<h4></h4>").html("Application Fees")).append(info.estimates);
            	}

            	if (info.notes) {
            		$("#product_info").append($("<h4></h4>").html("Internal Notes")).append(info.notes);
            	}
	            
	            $.ajax({
	                data: {op: "getClientEntities", id: this.client_id},
	                success: (entities) => {
	                    vm.input.billing = entities;
	                    vm.input.billing_id = entities.length > 0 ? entities[0].id : 0;
	                    vm.input.invoicable_id = 0;
	                    vm.input.description = "";
	                    vm.input.amount = 0;
	                    vm.input.vat = 0;
	                    vm.input.discount = 0;
	                }

	            })

	        })
	    })
	}

	save(data) {
		let params = {
			id: this.product_id,
			client: this.client_id,
			billing: data.billing_id,
			item: data.invoicable_id,
			description: data.description,
			amount: data.amount,
			vat: data.vat,
			discount: data.discount,
			ponumber: data.ponumber,
			op: "createInvoice"
		};

		$.ajax({
			data: params
		});
	}

}

export default CreateInvoice;
